import { useEffect } from "react";

export const useSetDocumentTitle = (title: string) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);
};
